import { render } from "./PhoneNumberLinks.vue?vue&type=template&id=00dcf83a&scoped=true&ts=true"
import script from "./PhoneNumberLinks.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberLinks.vue?vue&type=script&lang=ts"

import "./PhoneNumberLinks.vue?vue&type=style&index=0&id=00dcf83a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dcf83a"]])

export default __exports__